import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { LocalStoreService } from '../../../../shared/services/common/local-store/local-store.service';

declare var $: any;
declare let gtag: Function;
declare let fbq: Function;

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

	isCappsHeader: boolean = false;

	constructor(
		private router: Router,
		private localStore: LocalStoreService
	) {

		if (environment.capps) {
			this.isCappsHeader = true;
		}
		else if (environment.hdfc) {
			this.isCappsHeader = false;
		}

		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(({ urlAfterRedirects }: NavigationEnd) => {

				//GTAG Code
				//if (urlAfterRedirects == '/mega-trading-days' || urlAfterRedirects == '/mega-trading-days1' || urlAfterRedirects == '/hindi/mega-trading-days') {
				//	if (gtag)
				//		gtag('event', 'conversion', {
				//			'allow_custom_scripts': true,
				//			'send_to': 'DC-11234930/invmedia/hdfcs00+standard'
				//		});
				//} else
				if (urlAfterRedirects == '/thank-you') {
					if (fbq)
						fbq('track', 'Lead');
					if (gtag)
						gtag('event', 'conversion', { 'send_to': 'AW-461930956/JOcuCNmR0fUCEMyDotwB' });
				}

				$(document).on("focus", ":input[type=tel]", function () {
					$(this).on("keyup", function (e) {
						if (/\D/g.test(this.value)) {
							this.value = this.value.replace(/\D/g, '');
						}
					});
				});

				//Remove multiple space between word and keep only one space.
				$(document).on("blur", ":input[type=text]", function () {
					var dest = $(this);
					dest.val(dest.val().replace(/\s\s+/g, ' ').trim());
				});

				$(document).on("keyup", ".alphanumeric", function (e) {
					this.value = this.value.replace(/[^a-zA-Z0-9]/g, '');
				});

				$(document).on("keyup", ".alphanumericspace", function (e) {
					this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
				});

				$(document).on("keyup", ".alphaspace", function (e) {
					this.value = this.value.replace(/[^a-zA-Z ]/g, '');
				});

				$(document).on("keyup", ".numeric", function (e) {
					if (/\D/g.test(this.value)) {
						this.value = this.value.replace(/\D/g, '');
					}
				});

			});
	}

	ngOnInit() {

		$(document).ready(function () {
			// $(".sidebar-mobile-modal-btn").click(function() {
			//   $(this).find("#toggle").toggleClass("on");
			// });
			$('[data-toggle="tooltip"]').tooltip();
		});
	}
}
